import { Component, TemplateRef, input, contentChild, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "stages-carousel-item",
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./carousel-item.component.html",
})
export class CarouselItemComponent {
	//@ViewChild(TemplateRef, { read: TemplateRef }) template: TemplateRef<unknown>; // eager
	readonly template = contentChild(TemplateRef, { read: TemplateRef }); // lazy
	readonly name = input<string>();
	position!: number;
}
